import {
  PeerReviewMeaningfulScore,
  peerReviewScoreProperties,
} from '@breakoutlearning/firebase-repository/models/RoomStateUPRPeerReview'
import { peerReviewScoreColor } from '@breakoutlearning/firebase-repository/sources-of-truth/peerReviewScores'
import classNames from 'classnames'
import { useTranslationTyped } from 'i18n/i18n'

export const PeerReviewMeaningOfScores = ({
  className,
}: {
  className?: string
}) => {
  const { tt } = useTranslationTyped()

  return (
    <div
      className={classNames('flex flex-col gap-2 overflow-y-auto', className)}
    >
      <div className="flex items-center justify-start">
        <h3 className="text-title-medium">
          {tt.instructor_assignment.configure_assignment_dialog.scoring_options()}
        </h3>
      </div>

      <div
        className={classNames('flex flex-col gap-2 overflow-y-auto', className)}
      >
        {Object.values(PeerReviewMeaningfulScore).map((option) => {
          const property = peerReviewScoreProperties[option]

          return (
            <div
              key={property.longLabel}
              className="flex items-center gap-2 rounded-lg"
            >
              <div className="flex size-8 shrink-0 items-center justify-center">
                <div
                  className={classNames(
                    'size-6 rounded-full',
                    peerReviewScoreColor(property.numericalValue)
                  )}
                />
              </div>
              <p className="text-label-medium">{property.longLabel}</p>
            </div>
          )
        })}
      </div>
    </div>
  )
}
